import { useMutation } from '@tanstack/react-query';

import { triggerHotelBidProcessing } from '~/services/PublicOfferFeedService';

export function useTriggerHotelBidProcessing() {
  return useMutation({
    mutationFn: triggerHotelBidProcessing,
  });
}
